import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative rounded-3xl overflow-hidden shadow-2xl border border-gold/20" data-id="element-142">
          <div className="absolute inset-0 bg-gradient-to-br from-cream to-white z-0" data-id="element-143"></div>
          <div className="absolute top-0 left-0 w-full h-2 bg-gold z-10" data-id="element-144"></div>

          <div className="relative z-10 p-8 md:p-16 text-center" data-id="element-145">
            <h2 className="text-2xl md:text-4xl font-bold text-navy-900 mb-8 leading-tight" data-id="element-146">
              En los próximos 7 días, podrías pasar de la incertidumbre total a
              tener{' '}
              <span className="text-gold" data-id="element-147">
                tu primer activo digital funcionando.
              </span>
            </h2>

            <div className="bg-navy-900/5 rounded-2xl p-6 md:p-10 mb-8" data-id="element-148">
              <p className="text-xl md:text-2xl text-slate-700 italic font-medium leading-relaxed" data-id="element-149">
                "Imagina despertar mañana, revisar tu celular y ver una
                notificación de Shopify:{' '}
                <strong className="text-green-600 bg-green-50 px-2 py-1 rounded" data-id="element-150">
                  Has recibido un pago de $27.00
                </strong>
                . Ese es el momento donde entiendes que ya no dependes de un
                solo cheque."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}